import gql from 'graphql-tag'

import { ProductVariantFields } from '../ProductVariantFields'
import { RichContentHtml } from '../RichContentHtml'

export const AllWidgets = gql`
  fragment ResponsiveProductBlockCarouselProductFields on Product {
    sku
    title
    brand {
      name
    }
    marketedSpecialOffer {
      title {
        content {
          type
          content
        }
      }
      description {
        content {
          type
          content
        }
      }
      landingPageLink {
        text
        url
        openExternally
        noFollow
      }
    }
    images {
      thumbnail
      largeProduct
      zoom
      __typename
    }
    reviews {
      averageScore
      total
      __typename
    }
    variants {
      sku
      price(currency: $currency, shippingDestination: $shippingDestination) {
        price {
          displayValue
          amount
        }
        rrp {
          displayValue
          amount
        }
      }
    }
    url
    __typename
  }

  fragment AllWidgets on Widget {
    id
    ... on AccordionWidget {
      __typename
      title
      content {
        ...RichContentHtml
        __typename
      }
    }

    ... on AccordionWidgetContainer {
      titlePosition
      heading
      title
      banners {
        ... on AccordionWidget {
          __typename
          title
          content {
            ...RichContentHtml
            __typename
          }
        }
      }
      __typename
    }

    ... on asymmetricGrid {
      widthImageTwoMobile
      imageOneSubtitle
      linkOne
      widthImageOneMobile
      altTextImgOne
      title
      altTextImgTwo
      imageTwoSubtitle
      imageOnePath
      imageTwoPath
      widthImageTwo
      widthImageOne
      linkTwo
    }

    ... on BMICalculator {
      calculateButtonText
      imperialDefault
      formSummaryObeseWeightTitle
      formSummaryDefaultTitle
      nextButtonText
      formSummaryUnderWeightTitle
      nextButtonOverWeightLink
      formSummaryDefaultText
      widgetTitle
      formSummaryNormalWeightText
      nextButtonUnderWeightLink
      formSummaryOverWeightText
      nextButtonNormalWeightLink
      widgetSubtitle
      formSummaryNormalWeightTitle
      formSummaryOverWeightTitle
      nextButtonObeseWeightLink
      formSummaryUnderWeightText
      formSummaryObeseWeightText
    }

    ... on BMICalculatorV2 {
      nextButtonUnderWeightLink
      imperialDefault
      nextButtonNormalWeightLink
      nextButtonText
      widgetSubtitle
      nextButtonOverWeightLink
      nextButtonObeseWeightLink
      widgetTitle
    }

    ... on buildyourownbundle {
      bundlePageTitle
      buildyourownbundleMaxProducts: maxProducts
      packSummary
      showPrices
      summaryAmount
      bundleSubTitle
      # banners {
      #   ...allWidgets
      # }
    }

    ... on BuildYourOwnBundleProductList {
      maxSelectableProducts
      disablePackQuantity
      quantitySelector
      # buildYourOwnBundleProductList: productList
      productCount
      list_row_bundle_size
      maxSelectableErrorMessage
      widgetTitle
    }

    ... on categoryItemCard {
      itemTitle
      textAlignment
      itemImagePath
      itemDescription
      altTextitem
      itemUrl
      itemCTA
    }

    ... on coverageCalculator {
      calculatorSubtitle
      additionalInfoTitle
      additionalInfoDisclaimerText
      paintCoverage
      calculatorType
      excludeAreaHelpText {
        ...RichContentHtml
      }
      instructionsTitle
      additionalInfoText {
        ...RichContentHtml
      }
      buyButtonLink
      paintCoatsHelpText {
        ...RichContentHtml
      }
      calculatorTitle
      instructionsText {
        ...RichContentHtml
      }
      wallpaperRollWidth
      wallpaperRollLength
    }

    ... on DeliveryInformationWidget {
      hasDetails
      sectionTitle
      sectionDetails {
        ...RichContentHtml
      }
      deliveryPrice
      deliveryOption
    }

    ... on DynamicReferralWidget {
      friendsNote
      codeSubtitle
      mainTitle
      codeTitle
      showYourCodeSection
      mainSubtitle
      sharingTitle
      balanceNote
      copyTitle
      copySubtitle
      sharingSubtitle
    }

    ... on EditorialWidget {
      editorialWidgetText: content {
        ...RichContentHtml
        __typename
      }
    }

    ... on GlobalReferral3StepGuide {
      title
      subtitle
      smallprint
      step1icon
      step1title
      step1text
      step2text
      step2icon
      step2title
      step3icon
      step3text
      step3title
    }

    ... on eightLinkButtonWidget {
      buttonUrlSix
      buttonTextOne
      buttonTextSix
      buttonTextEight
      buttonTextTwo
      buttonUrlTwo
      buttonUrlOne
      title
      buttonUrlThree
      buttonUrlEight
      buttonTextFour
      buttonUrlSeven
      titleAlign
      buttonTextSeven
      buttonUrlFive
      buttonTextThree
      buttonTextFive
      buttonUrlFour
    }

    ... on EmailReEngagementModal {
      imageAltText
      imageMedium
      emailReEngagementTitleText
      emailReEngagementBulletText3
      emailReEngagementBulletText2
      emailReEngagementBulletText1
      imageSmall
      imageLarge
      emailReEngagementOptInDiscount
    }

    ... on FastTrackBanner {
      fastTrackUrl
      fastTrackContent
      fastTrackHeader
    }

    ... on GlobalAboutUsVideo {
      buttonText
      transcript {
        ...RichContentHtml
      }
      videoURL
      buttonLink
      globalAboutUsVideoTextBlock: textBlock {
        ...RichContentHtml
      }
      title
      videoTitle
    }

    ... on GlobalAccreditationIcon {
      imageAltText
      altText
      imagePath
      title
      url
      openNewWindow
    }

    # ... on GlobalAccreditationIconCollection {
    #   # banners {
    #   #   ...allWidgets
    #   # }
    # }

    ... on GlobalBrandLogos {
      itemTwoURL
      itemSixURL
      itemThreeImageAlt
      itemTwoImage
      itemFiveImage
      itemThreeURL
      itemFourImageAlt
      itemFiveURL
      itemSixImage
      itemFourImage
      title
      itemTwoImageAlt
      itemFourURL
      itemThreeImage
      brandLogosItemOneVariantURL
      titleAlign
      itemOneImageAlt
      itemFiveImageAlt
      itemSixImageAlt
      isScrollable
      itemOneURL
      brandLogosItemOneImageVariantAlt
      itemOneImage
      brandLogosItemOneImageVariant
    }

    ... on GlobalBuyingRightNow {
      skufour {
        ...ProductVariantFields
      }
      productTextThree
      productTextTwo
      productTextFour
      skutwo {
        ...ProductVariantFields
      }
      productTextOne
      sku {
        ...ProductVariantFields
      }
      title
      skuthree {
        ...ProductVariantFields
      }
    }

    ... on GlobalBuyingRightNowManualProductURL {
      skufour {
        ...ProductVariantFields
      }
      productTextThree
      productTextFour
      productTextOne
      title
      url3
      productTextTwo
      url4
      url1
      url2
      skutwo {
        ...ProductVariantFields
      }
      sku {
        ...ProductVariantFields
      }
      skuthree {
        ...ProductVariantFields
      }
    }

    ... on GlobalCardScrollerCard {
      image
      buttonText
      colorOfText
      altText
      verticalPositionOfText
      subtitle
      title
      url
    }

    ... on GlobalCardScrollerSet {
      title
      banners {
        ... on GlobalCardScrollerCard {
          __typename
          image
          buttonText
          colorOfText
          altText
          verticalPositionOfText
          subtitle
          title
          url
        }
      }
      cardStyle
    }

    ... on GlobalDispatchAndDateCountdownWidget {
      secondsTitle
      dispatchIcon
      dispatchTimeForThursday
      removeOnEnd
      dispatchTimeForWednesday
      dispatchTimeForFriday
      hoursTitle
      minutesTitle
      countDownEndHour
      dispatchTimeForSunday
      countDownEndSeconds
      linkUrl
      defaultNextDayDeliveryCutoff
      dispatchTimeForSaturday
      dispatchTimer
      weeksTitle
      direction
      dispatchTimeForMonday
      showTimer
      countDownSubTitle
      dispatchTimeForTuesday
      countDownTitle
      countDownEndMonth
      countDownEndYear
      daysTitle
      countDownEndDay
      separator
      size
      decrement
      useLocal
      textAlignment
      countDownEndMinutes
    }

    ... on GlobalEditorialWithFeature {
      imageOneSmall
      imageFeaturedLarge
      linkItemOne
      imageFeaturedSmall
      linkItemTwo
      imageOneLarge
      titleItemTwo
      CTAFeatured
      altItemTwo
      linkFeatured
      description
      altTextFeatured
      title
      descriptionFeatured
      imageTwoLarge
      descriptionItemOne
      CTAItemOne
      altTextItemOne
      titleFeatured
      descriptionItemTwo
      imageTwoSmall
      CTAItemTwo
      titleItemOne
    }

    ... on GlobalFooterAccreditationIcons {
      image2Href
      Image3Href
      image3
      image1Alt
      image1Href
      Image2Alt
      Image3Alt
      image1
      image2
    }

    ... on GlobalFooterContactUs {
      line7
      line6
      line5
      line4
      line10
      line9
      line8
      title
      line3
      line2
      line1
    }

    ... on GlobalFourBestSellers {
      ProductTwoButtonText
      ProductTwo {
        ...ProductVariantFields
        __typename
      }
      ProductThreeButtonText
      ProductFourButtonText
      ProductOneButtonText
      ProductOne {
        ...ProductVariantFields
        __typename
      }
      Title
      ProductThree {
        ...ProductVariantFields
        __typename
      }
      disableTitle
      ProductFour {
        ...ProductVariantFields
        __typename
      }
    }

    ... on GlobalFourButtonLink {
      buttonTextOne
      buttonTextThree
      buttonTextTwo
      buttonUrlTwo
      buttonUrlOne
      buttonUrlThree
      buttonTextFour
      buttonUrlFour
    }

    ... on GlobalFourItemEditorial {
      itemTwoCTA
      itemFourDescription
      itemTwoImage
      altItemTwo
      itemTwoSubtitle
      itemThreeCTA
      itemFourSubtitle
      itemThreeSubtitle
      altItemFour
      itemFourImage
      itemThreeImage
      itemFourCTA
      itemThreeDescription
      itemOneDescription
      itemOneUrl
      itemTwoDescription
      itemFourTitle
      itemOneImage
      itemTwoUrl
      itemTwoTitle
      altItemThree
      widgetLinkText
      itemThreeUrl
      itemOneTitle
      itemFourUrl
      widgetTitle
      noWrapItems
      styleModifier
      widgetLink
      itemThreeTitle
      itemOneSubtitle
      itemOneCTA
      textAlignment
      widgetSubtitle
      altItemOne
    }

    ... on GlobalGeneralImageBanner {
      imageAltText
      largeImage
      smallImage
      mediumImage
      linkUrl
    }

    ... on GlobalHelpCentreAccordion {
      accordionContent {
        ...RichContentHtml
      }
      accordionHeading
    }

    ... on GlobalHelpCentreAccordion2 {
      accordionContent {
        ...RichContentHtml
      }
      accordionHeading
    }

    ... on GlobalHelpCentreAccordionCollection {
      title
      # banners {
      #   ...allWidgets
      # }
    }

    ... on GlobalHelpCentreCollection {
      __typename
      banners {
        __typename
        ... on GlobalHelpCentreAccordionCollection {
          __typename
          title
          banners {
            __typename
            ... on GlobalHelpCentreAccordion {
              accordionHeading
              accordionContent {
                content {
                  content
                }
              }
            }
            ... on GlobalHelpCentreAccordion2 {
              accordionHeading
              accordionContent {
                content {
                  content
                }
              }
            }
          }
        }
      }
    }

    ... on GlobalHeroCTABanner {
      imageMedium
      buttonOne
      subtitle
      imageSmall
      imageDesktop
      buttonTwo
      imageExtraSmall
      headline
      buttonOneLink
      altTextImg
      buttonTwoLink
    }

    ... on GlobalImageCard {
      image
      buttonText
      colorOfText
      altText
      verticalPositionOfText
      subtitle
      noBorder
      title
      url
    }

    ... on GlobalImageCardSet {
      noBorder
      title
      banners {
        ... on GlobalImageCard {
          __typename
          image
          buttonText
          colorOfText
          altText
          verticalPositionOfText
          subtitle
          noBorder
          title
          url
        }
      }
      cardStyle
    }

    ... on GlobalMultiButton {
      multiButtonWidget_itemTwoURL
      multiButtonWidget_itemOneCTAText
      multiButtonWidget_itemOneURL
      multiButtonWidget_buttonStyle
      multiButtonWidget_itemTwoCTAText
      multiButtonWidget_itemThreeCTAText
      multiButtonWidget_itemThreeURL
      multiButtonWidget_itemFourURL
      multiButtonWidget_itemFourCTAText
      multiButtonWidget_itemFiveURL
      multiButtonWidget_itemFiveCTAText
      multiButtonWidget_itemSixURL
      multiButtonWidget_itemSixCTAText
    }

    ... on GlobalPrimaryBanner {
      ctaTwoURL
      imageMedium
      ctaTwo
      contentTheme
      contentAlign
      bannerURL
      altLogoPng
      ctaTwoAriaLabel
      ctaOne
      logopngWhiteBG
      imageLarge
      ctaOneAriaLabel
      logopngImageBG
      useH1
      subtitle
      imageSmall
      contentBoxPosition
      headline
      ctaOneURL
      altImageLarge
    }

    ... on GlobalPrimaryBannerWithList {
      ctaTwoURL
      imageMedium
      ctaTwo
      contentTheme
      contentAlign
      bannerURL
      altLogoPng
      ctaTwoAriaLabel
      ctaOne
      listBrowserSection
      logopngWhiteBG
      imageLarge
      ctaOneAriaLabel
      logopngImageBG
      subtitle
      imageSmall
      contentBoxPosition
      headline
      ctaOneURL
      altImageLarge
    }

    ... on GlobalPrimaryBannerWithTextOverlay {
      ctaTwoURL
      imageMedium
      ctaTwo
      contentTheme
      contentAlign
      altLogoPng
      bannerURL
      ctaTwoAriaLabel
      ctaOne
      logopngWhiteBG
      imageLarge
      ctaOneAriaLabel
      openInTabTwo
      hasMargin
      openInTabOne
      logopngImageBG
      useH1
      subtitle
      imageSmall
      contentBoxPosition
      headline
      ctaOneURL
      altImageLarge
    }

    ... on GlobalProductCardScroller {
      productSkuList {
        ...ProductVariantFields
      }
      hasArrows
      title
    }

    ... on GlobalScalableLogos {
      imagePathThree
      altTextOne
      urlFour
      urlTwo
      titleSix
      altTextThree
      urlThree
      altTextTwo
      titleFive
      titleOne
      urlOne
      titleThree
      urlSix
      imagePathFive
      altTextFive
      titleFour
      urlFive
      imagePathTwo
      imagePathSix
      imagePathFour
      altTextFour
      altTextSix
      imagePathOne
      titleTwo
    }

    ... on GlobalSectionPeek {
      __typename
      numberOfProducts
      title
      url
      titleAlign
      qubitPlacementId
    }

    ... on GlobalSetAndromeda {
      __typename
      columns
      banners {
        ... on GlobalWidgetSirius {
          __typename
          id
          image
          widgetSiriusAltTextVariant
          altText
          widgetSiriusImageVariant
          imagePosition
          widgetSiriusLinkVariant
          link
          widgetSiriusButtonVariant
          widgetSiriusTitleVariant
          title
          widgetSiriusHighlightVariant
          button
          highlight
          subTitle
          widgetSiriusSubTitleVariant
        }
      }
    }

    ... on GlobalSimpleTextCTAWidget {
      itemOneCTAText
      textAlign
      itemOneURL
      globalSimpleTextCTAWidgetText: text
      title
    }

    ... on GlobalSixItemCategories {
      itemTwoCTA
      itemTitleAlign
      itemTwoLink
      itemOneLink
      itemTwoImage
      altItemTwo
      altItemFive
      itemFiveImage
      itemThreeCTA
      itemSixImage
      altItemFour
      itemFourImage
      title
      itemCTAAlign
      itemThreeImage
      itemFourCTA
      itemFiveLink
      itemFourTitle
      itemThreeLink
      itemOneImage
      itemSixCTA
      itemTwoTitle
      itemFourLink
      altItemThree
      itemFiveCTA
      itemSixTitle
      itemOneTitle
      itemFiveTitle
      itemSixLink
      altItemSix
      itemThreeTitle
      itemOneCTA
      altItemOne
      __typename
    }

    ... on GlobalSocialIcon {
      icon
      url
    }

    ... on GlobalSocialIconCollection {
      title
      banners {
        ... on GlobalSocialIcon {
          icon
          url
        }
      }
    }

    ... on GlobalSocialIconCollectionv2 {
      title
      banners {
        ... on GlobalSocialIconv2 {
          icon
          url
        }
      }
    }

    ... on GlobalSocialIconv2 {
      icon
      url
    }

    ... on GlobalStripBanner {
      stripBannerTextPLP
      stripBannerURL
      stripBannerURLPDP
      stripBannerURLHomepage
      stripBannerText
      stripBannerURLBasket
      stripBannerTextPDP
      stripBannerURLAccount
      stripBannerTextBasket
      stripBannerTextAccount
      stripBannerURLPLP
      stripBannerTextHomepage
    }

    ... on GlobalSubscriptionOptions {
      subscriptionOptionsSkuFour
      subscriptionOptionsSkuTwoUspMessage
      subscriptionOptionsSkuFourDeliveryInfo
      subscriptionOptionsSkuTwoPrice
      subscriptionOptionsSkuOne
      subscriptionOptionsSkuOneTitle
      subscriptionOptionsSkuThreeTitle
      subscriptionOptionsSkuFourPriceAppend
      subscriptionOptionsSkuFourImage
      subscriptionOptionsSkuFourUspMessage
      subscriptionOptionsSkuTwoImage
      subscriptionOptionsSkuTwoSaveMessage
      subscriptionOptionsSkuFourSaveMessage
      subscriptionOptionsSkuThree
      subscriptionOptionsSkuThreePriceAppend
      subscriptionOptionsSkuOneDeliveryInfo
      subscriptionOptionsSkuThreeImage
      subscriptionOptionsSkuFourCTAText
      subscriptionOptionsSkuOneUspMessage
      subscriptionOptionsSkuOnePriceAppend
      subscriptionOptionsSkuThreePrice
      subscriptionOptionsShowRibbon
      subscriptionOptionsSkuTwoCTAText
      subscriptionOptionsSkuOneSaveMessage
      subscriptionOptionsSkuThreeDeliveryInfo
      subscriptionOptionsSkuFourTitle
      subscriptionOptionsSkuThreeCTAText
      subscriptionOptionsSkuTwoPriceAppend
      subscriptionOptionsSkuThreeUspMessage
      subscriptionOptionsSkuThreeSaveMessage
      subscriptionOptionsRibbonMessage
      subscriptionOptionsSkuOnePrice
      subscriptionOptionsSkuTwo
      subscriptionOptionsSkuOneImage
      subscriptionOptionsSkuTwoDeliveryInfo
      subscriptionOptionsSkuTwoTitle
      subscriptionOptionsSkuFourPrice
      subscriptionOptionsSkuOneCTAText
    }

    ... on GlobalTabbedWidgetSet {
      tabbedWidgetSetTitle
      tabbedWidgetTabTitle_1
      tabbedWidgetTabTitle_2
      tabbedWidgetSetSubTitle
    }

    ... on GlobalThreeItemEditorialSubtitleBG {
      itemOneCTAText
      itemTwoImage
      itemTwoSubtitle
      itemTwoCTAText
      description
      itemThreeSubtitle
      title
      itemTwoSubtitleBGColour
      itemThreeCTAText
      itemThreeImage
      itemThreeDescription
      itemOneDescription
      itemOneUrl
      itemTwoDescription
      itemOneImage
      itemTwoAltText
      itemTwoTitle
      itemTwoUrl
      itemOneAltText
      itemThreeUrl
      itemOneTitle
      itemOneSubtitleBGColour
      itemThreeSubtitleBGColour
      itemThreeTitle
      itemOneSubtitle
      itemThreeAltText
    }

    ... on GlobalTransformationSlider {
      beforeImageAltText
      beforeImageMedium
      titlePosition
      dividingLineColor
      dragButtonPosition
      dragLinePosition
      title
      afterImageMedium
      afterImageAltText
      afterImageLarge
      beforeImageLarge
      beforeImageSmall
      afterImageSmall
    }

    ... on GlobalTrendingHashtagBlock {
      url
      hashtag
    }

    # ... on GlobalTrendingHashtagCollection {
    #   # banners {
    #   #   ...allWidgets
    #   # }
    # }

    ... on GlobalTwoBestSellers {
      ProductTwoButtonText
      ProductTwo {
        __typename
        ...ProductVariantFields
      }
      ProductOneButtonText
      ProductOne {
        __typename
        ...ProductVariantFields
      }
    }

    ... on GlobalTwoItemEditorial {
      itemTwoTitle
      itemTwoURL
      itemOneCTAText
      itemTwoImage
      altItemTwo
      itemTwoCTAText
      itemOneTitle
      widgetTitle
      itemOneDescription
      itemOneURL
      widgetSubtitle
      itemTwoDescription
      altItemOne
      itemOneImage
    }

    ... on GlobalThreeItemEditorial {
      threeItemItemOneCTATextVariant
      itemOneCTAText
      itemThree_secondaryCTAUrl
      itemTwoImage
      altItemTwo
      itemTwoSubtitle
      threeItemItemOneSubtitleVariant
      itemTwoCTAText
      useCircularImages
      itemTwo_secondaryCTAUrl
      itemThreeSubtitle
      threeItemItemOneVariantUrl
      itemOne_secondaryCTAUrl
      itemThreeCTAText
      itemThreeImage
      itemThreeDescription
      itemOne_secondaryCTAText
      itemOneDescription
      itemOneUrl
      itemTwoDescription
      itemOneImage
      threeItemItemOneDescriptionVariant
      threeItemItemOneImageVariant
      itemTwoUrl
      itemTwoTitle
      altItemThree
      itemThreeUrl
      itemOneTitle
      threeItemItemOneTitleVariant
      threeItemItemOneAltTextVariant
      widgetHeadingSize
      widgetTitle
      itemTwo_secondaryCTAText
      itemThree_secondaryCTAText
      itemThreeTitle
      itemOneSubtitle
      widgetSubtitle
      altItemOne
    }

    ... on GlobalTwoItemImageTextBlock {
      button2Url
      itemButton
      itemAlign
      itemTitle
      textAlign
      itemImageSmall
      videoTitle
      itemText {
        ...RichContentHtml
        __typename
      }
      itemImage
      transcript {
        ...RichContentHtml
        __typename
      }
      itemAlt
      videoUrl
      button2Text
      itemURL
    }

    ... on GlobalTwoItemImageTextCTA {
      itemTwoURL
      itemTwoTitle
      itemTwoImageSmall
      itemOneCTAText
      contentTheme
      itemTwoImage
      itemTwoCTAText
      itemOneTitle
      itemOneDescription
      itemOneImageSmall
      itemOneURL
      itemOneImageAltText
      itemTwoDescription
      itemOneContentAlign
      itemTwoContentAlign
      itemOneImage
      itemTwoImageAltText
    }

    ... on GlobalTwoItemImageTextCTA3070 {
      itemTwoURL
      itemTwoTitle
      itemTwoImageSmall
      itemOneCTAText
      contentTheme
      itemTwoImage
      itemTwoCTAText
      itemOneTitle
      itemOneDescription
      itemOneImageSmall
      itemOneURL
      itemOneImageAltText
      itemTwoDescription
      itemOneContentAlign
      itemTwoContentAlign
      itemOneImage
      itemTwoImageAltText
    }

    ... on GlobalUGCCarousel {
      ugcSubText
      tag
      ugcTitle
      category
    }

    ... on GlobalVideoGallery {
      itemTwoCTA
      useTitleHeadingLevel2
      itemSixVideoURL
      itemFiveTranscript {
        ...RichContentHtml
      }
      itemTwoImage
      itemFiveVideoURL
      itemSixButtonLink
      itemFiveImage
      itemOneVideoURL
      itemTwoButtonLink
      itemThreeCTA
      itemSixImage
      itemFourImage
      title
      itemThreeImage
      itemOneButtonLink
      itemFourCTA
      itemThreeImageAltText
      itemOneTranscript {
        ...RichContentHtml
      }
      itemFourTranscript {
        ...RichContentHtml
      }
      itemFourTitle
      itemOneImageAltText
      itemOneImage
      itemSixCTA
      itemTwoTitle
      itemFourVideoURL
      itemSixTranscript {
        ...RichContentHtml
      }
      itemFiveButtonLink
      itemSixImageAltText
      textAlign
      itemTwoVideoURL
      itemThreeVideoURL
      itemFiveCTA
      itemSixTitle
      itemOneTitle
      textBlock
      itemFiveTitle
      itemFiveImageAltText
      itemFourImageAltText
      itemThreeTitle
      itemFourButtonLink
      itemOneCTA
      itemThreeTranscript {
        ...RichContentHtml
      }
      itemTwoTranscript {
        ...RichContentHtml
      }
      itemThreeButtonLink
      itemTwoImageAltText
    }

    ... on GlobalVideoHeroBannerWidget {
      videoPreviewImageMobile
      videoPreviewImage
      muteVideo
      videoAssetPathMp4
      videoAssetPathWebm
      autoplayVideo
      videoTitle
      VideoPreviewImageTablet
    }

    ... on GlobalVideoTextImageCTA {
      itemImageLink
      itemCTALink
      videoUrl
      itemDescription
      itemImage
      widgetTitle
      itemCTA
    }

    ... on GlobalWaitListSignUpFormResponses {
      responseSubText {
        ...RichContentHtml
      }
      responseTitle
      responseStartSubText
      errorButtonText
      registerButtonText
      continueButtonText
      formResponse
    }

    ... on GlobalWaitListSignUpWidget {
      buttonText
      registeredReturnUrl
      fullNamePlaceholderText
      enableSignUp
      gdprDisclaimerText
      title
      noAccountReturnUrl
      signUpText
      subtitle
      placeholderText
      enableNameField
      campaignCode
      errorReturnUrl
    }

    ... on GlobalWidgetSirius {
      image
      widgetSiriusAltTextVariant
      altText
      widgetSiriusImageVariant
      imagePosition
      widgetSiriusLinkVariant
      link
      widgetSiriusButtonVariant
      widgetSiriusTitleVariant
      title
      widgetSiriusHighlightVariant
      button
      highlight
      subTitle
      widgetSiriusSubTitleVariant
    }

    ... on GlobalWidgetVega {
      container
      button
      highlight
      imageMobile
      subTitle
      textAlign
      containerBg
      link
      imageDesktop
      title
      altTextImg
    }

    ... on GlobalYoutubeGalleryItem {
      videoId
      title
    }

    # ... on GlobalYoutubeGallerySet {
    #   # banners {
    #   #   ...allWidgets
    #   # }
    # }

    ... on imageSelectCard {
      altTextThumbnail
      itemImageLargePath
      altTextImage
      itemImageSmallPath
      itemImagePath
      ImageInformationText
      thumbnailImagePath
    }

    ... on imageSelectSlider {
      altTextLogoImage
      logoImagePath
      titleText
      # banners {
      #   ...allWidgets
      # }
    }

    ... on improvedSearchBestSellers {
      productId2
      productId3
      productId4
      productId1
      widgetTitle
    }

    ... on kitBuilder {
      kitBuilderDistributorId
      kitBuilderKey
    }

    ... on LoyaltyHubBirthdayGift {
      banner
      description
      giftActive
      title
      userNotification
      customerLists
      modalHeading
      formInstruction
    }

    ... on LoyaltyHubTier {
      hidden
      rewardsHeader
      bannerAlt
      iconType
      banner
      title
      textPart1
      textPart2
      textPart3
    }

    ... on loyaltyRewardsList {
      listItem4
      listItem3
      listItem2
      listItem1
      listItem8
      listItem7
      listItem6
      listItem5
      title
    }

    ... on LoyaltyRewardTier {
      tierListItem3
      tierListItem4
      tierType
      tierListItem5
      tierName
      tierRange
      tierListItem1
      tierListItem2
    }

    # ... on LoyaltyRewardTiers {
    #   # banners {
    #   #   ...allWidgets
    #   # }
    # }

    ... on loyaltyWelcomeMessage {
      imageAltText
      subHeading
      heading
      imagePath
      accountCreationTextPart1
      accountCreationTextPart2
      profileCompletionTextPart1
      profileCompletionTextPart2
    }

    ... on MailingList {
      enablefreeAnswerField
      emailPlaceholderText
      fullNamePlaceholderText
      enableSignUp
      enableDropdownAnswerField
      dropdownAnswer5
      dropdownAnswer6
      dropdownAnswer3
      dropdownAnswer4
      dropdownAnswer1
      dropdownAnswer10
      dropdownAnswer2
      dropdownAnswer9
      dropdownAnswer7
      emailLabelText
      campaignCode
      dropdownAnswer8
      buttonText
      registeredReturnUrl
      gdprDisclaimerText
      fullNameLabelText
      widgetTitle
      signUpText
      dropdownAnswerQuestionText
      widgetSubtitle
      freeAnswerQuestionText
      dropdownAnswerPlaceholder
      enableNameField
      errorReturnUrl
    }

    ... on multiCategoryCardSet {
      __typename
      widgetSubtitle
      columnsNumber
      banners {
        ... on categoryItemCard {
          __typename
          itemTitle
          textAlignment
          itemImagePath
          itemDescription
          altTextitem
          itemUrl
          itemCTA
        }
      }
      widgetTitle
    }

    ... on MultipleCTABanner {
      ctaTwoURL
      imageMedium
      ctaTwo
      contentTheme
      altLogoPng
      bannerURL
      ctaOne
      imageLarge
      logopngImageBG
      subtitle
      imageSmall
      contentBoxPosition
      headline
      ctaOneURL
      altImageLarge
    }

    ... on parcelLabWidget {
      showZipCodeInput
      parcelLabUserId
      showSearchForm
    }

    ... on ProductListWidget {
      title
      descriptionHtml {
        ...RichContentHtml
        __typename
      }
    }

    ... on promoproductslider {
      featuredImage
      imageURL
      widgetSubtitle
      # productList
      productCount
      widgetTitle
    }

    ... on ResponsiveBuildYourOwnBundle {
      showInfoButton
      showCategoriesList
      expandAllCategories
      maxProducts
      showPrices
      summaryAmount
      bundleSubTitle
      showProductReviews
      # banners {
      #   ...allWidgets
      # }
      summaryDisplayType
      showBundlePageTitle
      unlimitedProducts
      showProductRRP
    }

    ... on ResponsiveBuildYourOwnBundleProducts {
      # skuList
      enableQuantitySelector
      maxProducts
      productsToShow
      categoryTitle
      # productList
    }

    ... on ResponsiveComparisonTable {
      featureTag
      comparisonList
      buttonText
      subTitle
      imageUrl
      title
      moreInfo
      buttonUrl
      disableFeatureTag
    }

    # ... on ResponsiveComparisonTableContainer {
    #   # banners {
    #   #   ...allWidgets
    #   # }
    # }

    ... on ResponsiveProductBlockCarousel {
      enableAsiaStyles
      title
      productList(
        input: {
          currency: $currency
          shippingDestination: $shippingDestination
          offset: 0
          limit: 20
          facets: []
        }
      ) {
        products {
          ...ResponsiveProductBlockCarouselProductFields
        }
      }
    }

    ... on ResponsiveProductTabs {
      tabTitle_1
      responsiveProductTabsTitle
      tabTitle_2
      tabTitle_3
    }

    ... on ResponsiveSetSalon {
      salonDescription
      salonTel
      beauty
      mondayHours
      sprayTan
      thursdayHours
      fridayHours
      # banners {
      #   ...allWidgets
      # }
      salonEmail
      tuesdayHours
      hair
      extensions
      sundayHours
      salonBookUrl
      wednesdayHours
      saturdayHours
      responsiveSetSalonSocialUrl: socialUrl
      salonTitle
    }

    ... on ResponsiveSetSalonWithSlides {
      salonDescription
      salonTel
      beauty
      sliderImage3
      sliderImage2
      sliderImage1
      mondayHours
      sprayTan
      thursdayHours
      fridayHours
      sliderImage2Alt
      salonEmail
      sliderImage3Alt
      sliderImage1Alt
      tuesdayHours
      hair
      extensions
      sundayHours
      salonBookUrl
      wednesdayHours
      saturdayHours
      socialUrl
      salonTitle
    }

    ... on ResponsiveSliderSet {
      isHeightVariable
      slideDuration
      banners {
        ... on GlobalPrimaryBanner {
          __typename
          ctaTwoURL
          imageMedium
          ctaTwo
          contentTheme
          contentAlign
          bannerURL
          altLogoPng
          ctaTwoAriaLabel
          ctaOne
          logopngWhiteBG
          imageLarge
          ctaOneAriaLabel
          logopngImageBG
          useH1
          subtitle
          imageSmall
          contentBoxPosition
          headline
          ctaOneURL
          altImageLarge
        }
      }
      isBulletNavigationHidden
      isAutoSlideOn
    }

    # ... on ResponsiveSuccessStoriesWidgetContainer {
    #   # banners {
    #   #   ...allWidgets
    #   # }
    # }

    ... on ResponsiveSuccessStoryWidget {
      profileName
      imageAltText
      profileCta
      weightLost
      roundelTitle
      imageUrl
      linkUrl
      caption
      imageAfterUrl
      weightLossStyle
      imageAfterAltText
    }

    ... on storyStreamWidget {
      id
      layoutClass
      storyStreamId
      integrityHash
    }

    ... on ResponsiveTwoItemComparisonContainer {
      title1
      title2
      # banners {
      #   ...allWidgets
      # }
    }

    ... on ResponsiveTwoItemComparisonRow {
      valueToCompare
      secondItem
      firstItem
      valueToCopmare
    }

    ... on ResponsiveUSPBar {
      clickAndCollectLink
      rewardPointsLink
      countDownLink
      internationalDeliveryLink
      qualityLink
      callIcon
      callLink
      emailText
      checkmarkLink
      internationalDeliveryText
      clickAndCollectText
      timezoneOffset
      saturdayCutoff
      callText
      fastTrackLink
      checkmarkText
      sundayCutoff
      deliveryText
      fastTrackText
      emailLink
      mondayCutoff
      deliveryLink
      countDownText
      qualityText
      storeLink
      rewardPointsText
      wednesdayCutoff
      fridayCutoff
      storeText
      tuesdayCutoff
      thursdayCutoff
    }

    ... on SeoProductCategory {
      productCategoryUrl
      productCategoryName
      buttonStyle
    }

    ... on SeoProductCategorySet {
      showDiscoverTag
      showMore
      # banners {
      #   ...allWidgets
      # }
    }

    ... on shopTheLook {
      imageMedium
      itemTitle
      imageSmall
      itemDescription
      imageLarge
      banners {
        __typename
        ... on ShopTheLookHotSpot {
          itemTop
          itemLeft
          rangeList
          SKU {
            ...ProductVariantFields
            marketedSpecialOffer {
              __typename
              title {
                content {
                  content
                }
              }
              description {
                content {
                  content
                }
              }
              landingPageLink {
                text
                url
                openExternally
                noFollow
              }
            }
          }
          productDescription
        }
      }
      altImageLarge
    }

    ... on ShopTheLookHotSpot {
      itemTop
      itemLeft
      rangeList
      SKU {
        ...ProductVariantFields
      }
      productDescription
    }

    ... on simpleCTA {
      CTAText
      title
      CTAUrl
      CTAStyle
    }

    ... on simpletextwidget {
      textAlign
      simpletextwidgetText: text {
        ...RichContentHtml
        __typename
      }
      title
    }

    ... on simpleTextWidgetSet {
      banners {
        ... on simpletextwidget {
          __typename
          textAlign
          simpletextwidgetText: text {
            ...RichContentHtml
            __typename
          }
          title
        }
      }
    }

    ... on simpletextwidgetwithh1 {
      textAlign
      simpletextwidgetText: text {
        ...RichContentHtml
        __typename
      }
      title
    }

    ... on simpleTitleWidget {
      additionalTitleStyles
      textAlign
      subtitle
      text
      title
      additionalSubtitleStyles
    }

    ... on sponsoredProducts {
      ProductTwo {
        ...ProductVariantFields
      }
      ctaOneAriaLabel
      contentTheme
      logopngImageBG
      useH1
      altLogoPng
      ProductOne {
        ...ProductVariantFields
      }
      ctaOne
      logopngWhiteBG
      text
      headline
      ctaOneURL
    }

    ... on sponsoredProductsNew {
      widgetVersion
    }

    ... on subscribeAndSaveInformationModal {
      imageAltText
      modalTitle
      modalContent {
        ...RichContentHtml
      }
      imageSmall
      imageLarge
    }

    ... on swatchSelectSlider {
      imageOneLink
      altTextLogoImage
      altTextImageOne
      imageTwoLink
      link
      titleThree
      thumbnailImageFourPath
      imageThreeLink
      thumbnailImageOnePath
      cta
      altTextThumbnailImageOne
      imageThreePath
      ctaLink
      titleTwo
      altTextThumbnailImageThree
      info
      altTextImageTwo
      titleOne
      imageFourPath
      count
      linkText
      titleFour
      altTextThumbnailImageTwo
      altTextImageFour
      logoImagePath
      thumbnailImageThreePath
      imageOnePath
      parentWidgetLink
      imageFourLink
      imageTwoPath
      altTextImageThree
      altTextThumbnailImageFour
      thumbnailImageTwoPath
    }

    ... on swatchSelectSliderSet {
      banners {
        ... on swatchSelectSlider {
          imageOneLink
          altTextLogoImage
          altTextImageOne
          imageTwoLink
          link
          titleThree
          thumbnailImageFourPath
          imageThreeLink
          thumbnailImageOnePath
          cta
          altTextThumbnailImageOne
          imageThreePath
          ctaLink
          titleTwo
          altTextThumbnailImageThree
          info
          altTextImageTwo
          titleOne
          imageFourPath
          count
          linkText
          titleFour
          altTextThumbnailImageTwo
          altTextImageFour
          logoImagePath
          thumbnailImageThreePath
          imageOnePath
          parentWidgetLink
          imageFourLink
          imageTwoPath
          altTextImageThree
          altTextThumbnailImageFour
          thumbnailImageTwoPath
        }
      }
    }

    ... on provenanceBrandHeader {
      brand
      brandId
      button2Text
      button2Url
      id
      itemAlign
      itemAlt
      itemButton
      itemImage
      itemImageSmall
      itemText {
        ...RichContentHtml
        __typename
      }
      itemTitle
      itemURL
      textAlign
      transcript {
        ...RichContentHtml
        __typename
      }
      videoTitle
      videoUrl
    }

    ... on TopBrandsWidget {
      altTextBrandSixLogo
      BrandFiveName
      BrandSixName
      BrandFiveLogoPath
      BrandSevenLogoPath
      BrandTabTitle
      featuredImagePath
      featuredBrandText
      BrandOneLogoPath
      BrandEightLogoPath
      altTextBrandThreeLogo
      BrandFourName
      BrandThreeLogoPath
      altTextBrandFiveLogo
      BrandSixLogoPath
      altTextBrandOneLogo
      BrandOneName
      BrandTwoLogoPath
      BrandTwoName
      featuredBrandPageLinkName
      featuredBrandPageLink
      altTextFeaturedLogo
      BrandEightName
      BrandFourLogoPath
      featuredBrandName
      BrandThreeName
      altTextBrandTwoLogo
      BrandSevenName
      altTextFeaturedImage
      altTextBrandEightLogo
      featuredLogoPath
      altTextBrandSevenLogo
      altTextBrandFourLogo
    }

    ... on TopProductCategory {
      buttonStyle
      topProductCategoryName
      topProductCategoryUrl
    }

    ... on TopProductCategorySet {
      showDiscoverTag
      showMore
      DiscoverTitle
      banners {
        ... on TopProductCategory {
          id
          __typename
          buttonStyle
          topProductCategoryName
          topProductCategoryUrl
        }
      }
    }

    ... on TrustPilotWidget {
      businessId
      width
      theme
      locale
      templateId
      url
      height
    }

    ... on trustReinforcementContainer {
      showStockInformation
      # banners {
      #   ...allWidgets
      # }
    }

    ... on trustReinforcementSection {
      modalBody {
        ...RichContentHtml
      }
      modalTitle
      subtitle
      icon
      title
    }
  }
`

export const AllWidgetsFragment = gql`
  ${ProductVariantFields}
  ${RichContentHtml}
  ${AllWidgets}
`
